import { getInitial, getInitialBackground } from "../../../../lib/utility";
import { formatToLocalDate } from "../../../../utils/formatToLocalDate";
import { feedsService } from "../../../../services/feedsService";
import { ratingService } from "../../../../services/ratingService";

export function RottenTomatoesReviewItem() {

    function render(feed: Record<string, any>, index: number) {
        const initialBackground = getInitialBackground();
        const dataObj: Record<string, any> = {
            'author_name': feed.author_name ?? '',
            'author_image_url': feed.author_image_url ?? '',
            'review_date': feed.review_date ?? '',
            'review_text': feed.review_text ?? '',
            'review_rating': feed.review_rating ?? '',
            'review_title': ''
        }
        let isDisplayFullText = feedsService.isDisplayFullText(dataObj.review_text);
        const ratingIcon = ratingService.getRatingIcon(1, dataObj.review_rating, 5);
        return /*html*/`
        <label for="rotten_tomatoes_single_feed_${index}"
            class="feedbox-card cursor-pointer border bg-white text-gray-800 block shadow-sm rounded-xl has-[:checked]:border-[#7BB2FA] dark:bg-neutral-900 dark:border-neutral-700 dark:shadow-neutral-700/70 dark:has-[:checked]:border-[#7BB2FA]">
            <div
                class="relative p-3 md:p-4 flex gap-4 flex-col group-[.is-list]:sm:flex-row group-[.is-list]:pr-12 group-[.is-list]:md:flex-row group-[.is-list]:md:items-center group-[.is-list]:xl:flex-row">
                <div
                class="flex flex-row gap-2 cursor-pointer items-center justify-between group-[.is-list]:flex-col group-[.is-list]:items-start group-[.is-list]:justify-start group-[.is-list]:min-w-[100px] group-[.is-list]:max-w-[100px]">
                <div class="flex flex-row gap-2 cursor-pointer items-center group-[.is-list]:flex-col group-[.is-list]:items-start group-[.is-list]:justify-start">
                    <div class="size-[46px] shrink-0 rounded-lg border border-gray-200 inline-flex justify-center items-center dark:border-neutral-700 overflow-hidden box-border">
                        ${dataObj.author_image_url
                            ? `<img class="w-full h-auto max-h-[46px] object-contain" src="${dataObj.author_image_url}" alt="${dataObj.author_name}" />`
                            : dataObj.author_name
                                ? `<span class="inline-flex items-center justify-center size-[46px] text-xl font-semibold leading-none rounded-lg ${initialBackground}">${getInitial(dataObj.author_name)}</span>`
                                : ""
                        }
                    </div>
                    <div>
                        ${dataObj.author_name ? `<h3 title="${dataObj.author_name}" class="font-medium text-gray-800 dark:text-white text-sm group-[.is-list]:text-sm line-clamp-1 hover:text-blue-600 break-words">${dataObj.author_name}</h3>` : ""}
                        ${dataObj.review_date ? `<p class="text-xs group-[.is-list]:text-[10px] font-normal text-gray-400 dark:text-neutral-500">${formatToLocalDate(dataObj.review_date)}</p>` : ""}
                    </div>
                </div>
                <div class="flex gap-2 items-center group-[.is-list]:absolute group-[.is-list]:top-[50%] group-[.is-list]:right-4 group-[.is-list]:mt-[-8px]">
                    <div class="flex shrink-0">
                        <input type="checkbox" id="rotten_tomatoes_single_feed_${index}"
                            class="toggleCheckbox cursor-pointer shrink-0 mt-0.5 border-gray-200 rounded text-blue-600 focus:ring-blue-500 disabled:opacity-50 disabled:pointer-events-none dark:bg-neutral-800 dark:border-neutral-700 dark:checked:bg-blue-500 dark:checked:border-blue-500 dark:focus:ring-offset-gray-800" />
                    </div>
                </div>
                </div>
                <div class="flex flex-col gap-3 w-full mt-2 group-[.is-list]:mt-0">
                    <div class="text-gray-500 dark:text-neutral-400 text-sm tx-normal flex flex-col gap-2">
                        <!-- Rating -->
                        ${dataObj.review_rating ? `
                        <div class="gap-x-1 flex items-center">
                            ${ratingIcon} 
                        </div>  
                        ` : ''}
                        <!-- End Rating -->
                        ${dataObj.review_title || dataObj.review_text ? `
                        <div class="text-gray-500 dark:text-neutral-400 text-sm tx-normal flex flex-col gap-2">
                        ${dataObj.review_title ? `<h4 class="relative text-gray-900 dark:text-neutral-300 text-sm tx-normal font-semibold">
                        ${dataObj.review_title}</h4>` : ''}
                        <div class="feed-text relative ${!isDisplayFullText ? "line-clamp-4 group-[.is-list]:line-clamp-2" : "" }">
                            <p>${dataObj.review_text}</p>
                            ${!isDisplayFullText
                            ? `<span class="view-details-link right-0 bottom-0 bg-white dark:bg-neutral-900 absolute">
                                <span class="">...</span>
                                <button class="read-more-less-btn text-gray-800 dark:text-gray-300 hover:text-blue-600 hover:underline hover:decoration-2 hover:decoration-blue-600 hover:opacity-80 focus:opacity-80 focus:outline-none text-sm font-medium cursor-pointer">View More</button>
                            </span>`
                            : ``}
                        </div>
                    </div>
                    ` : "" }
                </div>
              </div>
            </div>
        </label>`;
    }

    return {
        render
    };
}